<template>
  <div class="machine-shop">
    车间
  </div>
</template>

<script>
export default {
  name: 'MachineShop',
  data () {
    return {
    }
  },
  watch: {
  },
  async mounted () {
  },
  methods: {
  }

}
</script>

<style lang="scss">
</style>
